module.exports = __webpack_public_path__ + "static/img/pico50.dd45c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico50.png
// module id = ws1P
// module chunks = 0